import React from "react";
import assetify from "@quintype/framework/assetify";
import PropTypes from "prop-types";
import LoginImg from ".././../../../../assets/images/nl-images/subscriptionstaticpage.png";
import { Link } from "@quintype/components";
import { Popup } from "..";

import "./subscribe-popup.m.css";
import { getAuthUrl } from "../../../helper/hooks";

export const SubscribePopup = props => {
  const loginUrl = getAuthUrl();
  return (
    <Popup showModal={props.showModal} setShowModal={props.setShowModal} hideCloseIcon={props.hideCloseIcon}>
      <div styleName="subscribe-content-wrapper">
        <img src={assetify(LoginImg)} />
        <h2>Oops! This is available for subscriber only</h2>
        <p>
          Subscribe now to power our ad-free, independent journalism. Pay to
          keep news free
        </p>
        <Link href={"/subscription?ref=comment-popup"}>
          <button>Subscribe</button>
        </Link>
        <small>
          Already a subscriber?{" "}
          <a>
            <Link href={loginUrl}>Login</Link>
          </a>
        </small>
      </div>
    </Popup>
  );
};

SubscribePopup.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func
};
